import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppContext } from 'src/app/services/app-context.service';

@Component({
  selector: 'travel-ui-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.scss'],
})
export class FilterListComponent implements OnInit {
  config: any;
  @Input()
  set filter(data: any) {
    this.config = data;
    if (this.config.category === 'Facilities') {
      this.config.options.sort(function (
        a: { count: number },
        b: { count: number }
      ) {
        if (a.count > b.count) {
          return -1;
        }
        return 0;
      });
    }

    if (this.config?.category === 'StarRating') {
      this.config?.options.sort(function (a: { value: number; }, b: { value: number; }) {
        if (a.value > b.value) { return -1; }
        return 0;
      })
    }
    if(this.appContext.siteName =='ReservationsExpert' && this.config?.category === 'StarRating'){
      this.config.options = this.config.options
      .filter((option: { value: number }) => option.value.toString() !== '0')
    }
  }

  @Output() selectedFilter = new EventEmitter();

  showMore = false;
  showMoreText = 'Show more';

  constructor(public appContext: AppContext) {}

  checked(event: any, filter: any) {
    let filterApplied = false;
    const selectedOptions: any[] = [];
    filter.options.forEach((opt: any) => {
      if (filter.type === 'list') {
        if (opt.checked) {
          filterApplied = true;
          selectedOptions.push(opt.value);
        }
      } else if (filter.type === 'range') {
        if (opt.checked) {
          filterApplied = true;
          selectedOptions.push({ min: opt.min, max: opt.max });
        }
      }
    });
    this.selectedFilter.emit({
      name: filter.category,
      applied: filterApplied,
      selectedOptions,
    });
  }

  toggleDisplay() {
    this.showMore = !this.showMore;
    this.showMoreText = this.showMore ? 'Show less' : 'Show more';
  }

  ngOnInit() {}
}
